module.exports = __webpack_public_path__ + "static-portal/img/1-1.60cda6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/1-1.jpg
// module id = 9lqn
// module chunks = 4